import React, { useEffect, useState } from "react";
import { Modal, Slider, Checkbox, Input, message, Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  setCommercialQuickQuotes,
  setQuickQuotePost,
  setCommercialErrQuotes,
  setCommercialIDV,
  getComQuickQuotes,
  getComQuickQuotePost,
  getComQuickQuoteInput,
} from "../../../Redux/actions/CommercialSlice";
import axiosCommercial from "../../../Redux/axios/AxiosCommercial";
const IconSlider = (props) => {
  const dispatch = useDispatch();
  const QuickQuotes = useSelector(getComQuickQuotes);
  // console.log('side card',QuickQuotes)
  const { max, min } = props;
  const mid = Number(((max - min) / 2).toFixed(5));
  const [value, setValue] = useState();
  const preColorCls = value >= mid ? "" : "icon-wrapper-active";
  const nextColorCls = value >= mid ? "icon-wrapper-active" : "";
  let ex_showroom_price;
  let maximumIdv;
  let minimumIdv;

  const vehicleIDVObjects = QuickQuotes?.map(
    (item) => item?.vehicle?.vehicleIDV
  );
  // console.log('vehicleIDVObjects',vehicleIDVObjects)
  if (vehicleIDVObjects?.length > 0) {
    ex_showroom_price = vehicleIDVObjects[0]?.ex_showroom_price;
    // minimumIdv = decreasedIdv;
    // maximumIdv = increasedIdv;
  }
  const increasePercentage = ex_showroom_price * 0.1;
  const decreasePercentage = ex_showroom_price * 0.1;

  const increasedIdv = ex_showroom_price + increasePercentage;
  const decreasedIdv = ex_showroom_price - decreasePercentage;
  minimumIdv = decreasedIdv;
  maximumIdv = increasedIdv;
  const onChange = () => {
    setValue();
  };
  const handleInputChange = (e) => {
    setValue(e.target.value);
    if (e.target.value > QuickQuotes.vehicle.vehicleIDV.minimumIdv) {
      setValue(e.target.value);
    } else {
      return setValue(QuickQuotes.vehicle.vehicleIDV.minimumIdv);
    }
  };
  useEffect(() => {
    dispatch(setCommercialIDV(value));
    //localStorage.setItem("IDV", JSON.stringify(value));
  }, [value]);
  return (
    <div className="icon-wrapper">
      <div className="d-flex justify-content-between">
        <div className={preColorCls}>min IDV</div>
        <div className={nextColorCls}>max IDV</div>
      </div>
      <Slider {...props} onChange={setValue} value={value} />
      <div className="d-flex justify-content-between mb-3">
        <div className={preColorCls}>{minimumIdv}</div>
        <div className={nextColorCls}>{maximumIdv}</div>
      </div>
      <div className="mb-3">
        <Checkbox checked={value === minimumIdv} onChange={onChange}>
          Set for Lowest Price
        </Checkbox>
      </div>
      <div className="divider">
        <hr className="line" />
        <b className="d-flex justify-content-center m-2">or</b>
        <hr className="line" />
      </div>
      <div>
        Set your own IDV
        <Input
          defaultValue={ex_showroom_price}
          value={value}
          className="input-border mt-3"
          placeholder="Enter IDV value here"
          prefix="Rs."
          suffix="/-"
          bordered={false}
          onChange={handleInputChange}
          state={{ value }}
        />
      </div>
    </div>
  );
};

export const IdvCardCommercial = ({ CommerDetail }) => {
  const dispatch = useDispatch();
  const QuickQuotes = useSelector(getComQuickQuotes);
  const QuickQuotePost = useSelector(getComQuickQuotePost);
  const QuoteInput = useSelector(getComQuickQuoteInput);
  const IDV_VALUE = CommerDetail.idvValue;
  const CurrentTP = CommerDetail?.prevpolicydetail?.currentThirdPartyPolicy;
  const auth = CommerDetail?.commercialnum;
  // console.log('side card',QuickQuotes)
  // let { maximumIdv, minimumIdv, ex_showroom_price } = QuickQuotes ? QuickQuotes?.vehicle?.vehicleIDV : '';
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [QuotePost, setQuotePost] = useState(QuickQuotePost);
  // const [value, setValue] = useState(ex_showroom_price);
  const [loading, setLoading] = useState(false);
  let ex_showroom_price;
  let maximumIdv;
  let minimumIdv;
  const showModal = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    //setValue(IDV_VALUE);
  }, [IDV_VALUE]);

  const vehicleIDVObjects = QuickQuotes?.map(
    (item) => item?.vehicle?.vehicleIDV
  );
  // console.log('vehicleIDVObjects',vehicleIDVObjects)

  if (vehicleIDVObjects?.length > 0) {
    ex_showroom_price = vehicleIDVObjects[0]?.ex_showroom_price;
    // minimumIdv = decreasedIdv;
    // maximumIdv = increasedIdv;
  }
  const increasePercentage = ex_showroom_price * 0.1;
  const decreasePercentage = ex_showroom_price * 0.1;

  const increasedIdv = ex_showroom_price + increasePercentage;
  const decreasedIdv = ex_showroom_price - decreasePercentage;
  minimumIdv = decreasedIdv;
  maximumIdv = increasedIdv;

  //console.log(QuotePost)
  const handleOk = () => {
    // console.log("idv",IDV_VALUE)
    setLoading(true);
    const updatedQuotePost = {
      ...QuotePost,
      currentThirdPartyPolicy:
        QuickQuotePost?.product_code === "PVP" ? null : CurrentTP,
      vehIDV: parseInt(IDV_VALUE),
      defaultIDV: parseInt(IDV_VALUE),
      minimumIDV: minimumIdv,
      maximumIDV: maximumIdv,
    };
    // console.log(updatedQuotePost)
    axiosCommercial
      .post(
        `v2/commercial_insurances/${auth?.commercial_insurance_id}/quick_quotes`,
        updatedQuotePost
      )
      .then((res) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          //console.log("data-----------------",data)
          const errData = data?.filter(
            (item) => "status" in item && item.status === "failed"
          );
          dispatch(setCommercialErrQuotes(errData));
          const filteredData = data?.filter(
            (item) => "status" in item && item.status === "success"
          );
          const updatedData = filteredData?.map((item) => ({
            ...item,
            IsGst: true,
          }));
          dispatch(setCommercialQuickQuotes(updatedData));
          dispatch(setQuickQuotePost(updatedQuotePost));
          setLoading(false);
          setIsModalOpen(false);
        }
      })
      .catch((err) => {
        console.log(err.response.error);
        setLoading(false);
        setIsModalOpen(false);
        message.error("Something Went Wrong Please try again!");
      });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <div className="sideParent-skb mt-4">
        <div className="child1s-skb">
          <span>Insured Declared Value (IDV)</span>
          <div className="edit-button float-end" onClick={showModal}>
            {QuickQuotePost?.product_code === "PVT" ||
            QuoteInput?.productCode === "PVT"
              ? ""
              : "Edit"}
          </div>
        </div>

        <div className="child2s-skb">
          <p>
            IDV:{" "}
            {QuickQuotePost?.product_code === "PVT" ||
            QuoteInput?.productCode === "PVT"
              ? "N/A"
              : ex_showroom_price}
          </p>
        </div>
        {QuickQuotePost?.product_code === "PVT" ||
        QuoteInput?.productCode === "PVT" ? null : (
          <>
            <div className="child2s-skb">
              <p>MAXIMUM IDV: {maximumIdv}</p>
            </div>
            <div className="child2s-skb">
              <p>MINIMUM IDV: {minimumIdv}</p>
            </div>
          </>
        )}
      </div>
      <Modal
        title="Insured Declared value (IDV)"
        open={isModalOpen}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={handleOk}
          >
            Ok
          </Button>,
        ]}
      >
        <IconSlider min={minimumIdv} max={maximumIdv} />
        <div className="disclaimer">
          Your IDV should be 10% less than Previous Year Policy or as per
          depreciation norms of Indian Motor Tariff. Insurers consider the same
          during payment of a Total loss claim.
        </div>
      </Modal>
    </div>
  );
};

export default IdvCardCommercial;
